import React from 'react';
import './RotatingBanner.css';

const bookmakers = [
  'Arbitrage', 'Bankroll Management', 'Betfair', 'Deposit Bonuses', 'Mug Betting',
  'Promotions', 'Postive EV'
];

const RotatingBanner = () => {
  // Create three copies to ensure seamless infinite loop even on very wide screens
  const displayItems = [...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers,...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers];

  return (
    <div className="rotating-banner-container">
      <h3 className="banner-title">Master the ins and outs of sports betting:</h3>
      <div className="marquee">
        <div className="marquee-content">
          {displayItems.map((bookmaker, index) => (
            <span key={index} className="bookmaker">{bookmaker}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RotatingBanner;